function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as providerErrors from "./provider";
export const errors = _object_spread({}, providerErrors);
export * from "./provider";

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9lcnJvcnMvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0ICogYXMgcHJvdmlkZXJFcnJvcnMgZnJvbSAnLi9wcm92aWRlcidcblxuZXhwb3J0IGNvbnN0IGVycm9ycyA9IHtcbiAgLi4ucHJvdmlkZXJFcnJvcnMsXG59XG5cbmV4cG9ydCAqIGZyb20gJy4vcHJvdmlkZXInXG4iXSwibmFtZXMiOlsicHJvdmlkZXJFcnJvcnMiLCJlcnJvcnMiXSwicmFuZ2VNYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyIsIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsWUFBWUEsb0JBQW9CLGFBQVk7QUFFNUMsT0FBTyxNQUFNQyxTQUFTLG1CQUNqQkQsZ0JBQ0o7QUFFRCxjQUFjLGFBQVkifQ==